export function randomString(): string {
    return Math.random().toString(36).substring(2, 12);
}

/**
 * Random (optionally prefixed) string to be used as object IDs
 * 
 * Randomness is not as strong as with the Utils.guid as
 * the random part is generated using `Utils.randomString()`.
 * 
 * @param prefix Optional ID prefix
 * @returns Random object identifier
 */
export function objectIdentifier(prefix?: string) {
  return `${prefix ?? ''}${randomString()}`
}

export function guid() {
  // Came from https://gist.github.com/jed/982883, so let's not eslint it
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // tslint:disable-next-line
    let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
